export const offeringsLinks = [
  {
    listText: "Testosterone Replacement Therapy (TRT)",
    hrefText: "https://www.defymedical.com/services/trt/?_gl=1*1p6b4c5*_up*MQ..*_ga*OTYxNDk0Mjg0LjE3NTEzNjgzODk.*_ga_XWPYJFFXE5*czE3NTEzNjgzODgkbzEkZzAkdDE3NTEzNjgzODgkajYwJGwwJGgw",
  },
  {
    listText: "Skincare",
    hrefText: "https://www.defymedical.com/services/skin/?_gl=1*1t95u3w*_up*MQ..*_ga*OTYxNDk0Mjg0LjE3NTEzNjgzODk.*_ga_XWPYJFFXE5*czE3NTEzNjgzODgkbzEkZzAkdDE3NTEzNjgzODgkajYwJGwwJGgw",
  },
  {
    listText: "Female Sexual Dysfunction Treatment",
    hrefText: "https://www.defymedical.com/services/female-sexual-dysfunction/?_gl=1*82ulsj*_up*MQ..*_ga*OTYxNDk0Mjg0LjE3NTEzNjgzODk.*_ga_XWPYJFFXE5*czE3NTEzNjgzODgkbzEkZzAkdDE3NTEzNjgzODgkajYwJGwwJGgw",
  },
  {
    listText: "Bioidentical Hormone Restoration Therapy (BHRT)",
    hrefText: "https://www.defymedical.com/services/hormone-therapy/?_gl=1*1o4sk5x*_up*MQ..*_ga*MjEwNjgzNzQ1NC4xNzUxMzY5MDYz*_ga_XWPYJFFXE5*czE3NTEzNjkwNjEkbzEkZzAkdDE3NTEzNjkwNjEkajYwJGwwJGgw",
  },
  {
    listText: "Fat Loss and Weight Management",
    hrefText: "https://www.defymedical.com/services/weight-loss/?_gl=1*1t82mz2*_up*MQ..*_ga*OTYxNDk0Mjg0LjE3NTEzNjgzODk.*_ga_XWPYJFFXE5*czE3NTEzNjgzODgkbzEkZzAkdDE3NTEzNjgzODgkajYwJGwwJGgw",
  },
  {
    listText: "Anabolic Androgenic Therapies",
    hrefText: "https://www.defymedical.com/services/anabolic-androgenic-therapies/?_gl=1*1wz724q*_up*MQ..*_ga*MjEwNjgzNzQ1NC4xNzUxMzY5MDYz*_ga_XWPYJFFXE5*czE3NTEzNjkwNjEkbzEkZzEkdDE3NTEzNjkyMDIkajYwJGwwJGgw",
  },
  {
    listText: "Nutritional Supplementation",
    hrefText: "https://www.defymedical.com/services/vitamins-and-supplements/?_gl=1*j1qwda*_up*MQ..*_ga*OTYxNDk0Mjg0LjE3NTEzNjgzODk.*_ga_XWPYJFFXE5*czE3NTEzNjgzODgkbzEkZzAkdDE3NTEzNjgzODgkajYwJGwwJGgw",
  },
  {
    listText: "Primary Care",
    hrefText: "https://www.defymedical.com/services/primary-care/?_gl=1*1r83jq7*_up*MQ..*_ga*MjEwNjgzNzQ1NC4xNzUxMzY5MDYz*_ga_XWPYJFFXE5*czE3NTEzNjkwNjEkbzEkZzEkdDE3NTEzNjkyMjAkajQyJGwwJGgw",
  },
  {
    listText: "Ketamine Therapy",
    hrefText: "https://www.defymedical.com/services/ketamine-therapy/?_gl=1*nzry07*_up*MQ..*_ga*OTYxNDk0Mjg0LjE3NTEzNjgzODk.*_ga_XWPYJFFXE5*czE3NTEzNjgzODgkbzEkZzEkdDE3NTEzNjg3NTAkajYwJGwwJGgw",
  },
  {
    listText: "Thyroid Disease Management",
    hrefText: "https://www.defymedical.com/services/thyroid-therapy/?_gl=1*jlcnrr*_up*MQ..*_ga*MjEwNjgzNzQ1NC4xNzUxMzY5MDYz*_ga_XWPYJFFXE5*czE3NTEzNjkwNjEkbzEkZzEkdDE3NTEzNjkyNzMkajYwJGwwJGgw",
  },
  {
    listText: "Hair Loss Therapies",
    hrefText: "https://www.defymedical.com/services/hair-loss/?_gl=1*yu8f0i*_up*MQ..*_ga*OTYxNDk0Mjg0LjE3NTEzNjgzODk.*_ga_XWPYJFFXE5*czE3NTEzNjgzODgkbzEkZzAkdDE3NTEzNjgzODgkajYwJGwwJGgw",
  },
  {
    listText: "PRP Injections",
    hrefText: "https://www.defymedical.com/blog/prp-injections/?_gl=1*1e9bmx8*_up*MQ..*_ga*MjEwNjgzNzQ1NC4xNzUxMzY5MDYz*_ga_XWPYJFFXE5*czE3NTEzNjkwNjEkbzEkZzEkdDE3NTEzNjkzMzgkajYwJGwwJGgw",
  },
  {
    listText: "Hair Loss Solutions",
    hrefText: "https://www.defymedical.com/services/hair-loss/?_gl=1*yu8f0i*_up*MQ..*_ga*OTYxNDk0Mjg0LjE3NTEzNjgzODk.*_ga_XWPYJFFXE5*czE3NTEzNjgzODgkbzEkZzAkdDE3NTEzNjgzODgkajYwJGwwJGgw",
  },
];
